<div class="container">
  <div class="row">
    <div class="login-cont mx-auto">
      <div class="card login-form">
        <div class="card-header">Forgotten Password</div>
        <div class="card-body">
          <form (ngSubmit)="resetPassword(loginForm)" #loginForm="ngForm">
            <div class="form-group">
              <label for="exampleInputEmail1">Username</label>
              <input
                type="text"
                class="form-control auth-inp"
                required
                [(ngModel)]="formData.username"
                name="username"
                #username="ngModel"
                id="user-login-username"
                placeholder="Username"
                [readonly]="loading"
                required
              />
              <div class="inp-error" *ngIf="(username.dirty || username.touched) && !username.valid">Username is invalid.</div>
            </div>
            <button
            id='forgottenPasswordReset'  class="btn btn-primary btn-block btn-lg mt-2" type="submit" [disabled]="loading">Reset Password</button>
            <p class="text-center mt-2"><a
              id='forgottenPasswordBack' href="#" (click)="login()">Back</a></p>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/auth/forgotten-password/forgotten-password.component.html